import React, { FC, useState } from 'react'

import Tab from 'components/Tab'

import * as S from './style'
import BodyModal from './BodyModal'
import { MAX_LINE_UPLOAD_CSV, optionEnCodingsDownloadCsv } from 'constants/misc'

const TABS = [
  {
    label: '予約',
    id: 1,
  },
  {
    label: '予約可能枠',
    id: 2,
  },
]

type Props = {
  isOpen: boolean
  isShowUploadDelegation?: boolean
  uploadCsv: (file: File | null, encodingType: string) => Promise<void>
  uploadCsvDelegationBerth: (file: File | null, encodingType: string) => Promise<void>
  onClose: () => void
}

const CsvUploadModal: FC<Props> = ({
  isOpen,
  isShowUploadDelegation,
  uploadCsv,
  uploadCsvDelegationBerth,
  onClose,
}) => {
  const [encodingType, setEncodingType] = useState<string>(optionEnCodingsDownloadCsv[0].value)
  const [file, setFile] = useState<File | null>(null)
  const [hasErrorMultiple, setHasErrorMultiple] = useState<boolean>(false)
  const [tabIndex, setTabIndex] = useState(TABS[0].id)

  const [encodingTypeDelegation, setEncodingTypeDelegation] = useState<string>(
    optionEnCodingsDownloadCsv[0].value
  )
  const [fileDelegation, setFileDelegation] = useState<File | null>(null)

  const onChangeModalUploadCsv = async (e: any) => {
    const file = e.target.files[0]
    if (file) {
      setFile(file)
    }
  }

  const handleUploadCsv = () => {
    uploadCsv(file, encodingType)
    onHandleClickClose()
  }

  const onHandleClickClose = () => {
    onClose()
    setEncodingType(optionEnCodingsDownloadCsv[0].value)
    setFile(null)
  }

  const onChangeModalUploadCsvDelegation = async (e: any) => {
    const file = e.target.files[0]
    if (file) {
      const fileReader = new FileReader()
      fileReader.readAsText(e.target.files[0], encodingType)
      fileReader.onload = function () {
        const result = fileReader?.result?.toString()
        const numberOfLine = result?.match(
          /(?:"(?:[^"]|"")*"|[^,\n]*)(?:,(?:"(?:[^"]|"")*"|[^,\n]*))*\n/g
        )?.length!
        setHasErrorMultiple(numberOfLine - 1 > MAX_LINE_UPLOAD_CSV)
      }
      setFileDelegation(file)
    }
  }

  const handleUploadCsvDelegation = () => {
    uploadCsvDelegationBerth(fileDelegation, encodingTypeDelegation)
    onHandleClickCloseDelegation()
  }

  const onHandleClickCloseDelegation = () => {
    onClose()
    setEncodingTypeDelegation(optionEnCodingsDownloadCsv[0].value)
    setFileDelegation(null)
  }

  return (
    <S.CustomModal width={480} isOpen={isOpen}>
      <S.Title hasBottom={!isShowUploadDelegation}>CSVアップロード</S.Title>
      {isShowUploadDelegation && (
        <Tab
          className="mb-4"
          tabs={TABS}
          handleClick={function (id: number): void {
            setTabIndex(id)
          }}
        />
      )}
      {tabIndex === TABS[0].id ? (
        <BodyModal
          file={file}
          encodingType={encodingType}
          handleUploadCsv={handleUploadCsv}
          setEncodingType={setEncodingType}
          onChangeModalUploadCsv={onChangeModalUploadCsv}
          onHandleClickClose={onHandleClickClose}
        />
      ) : (
        <BodyModal
          hasErrorMultiple={hasErrorMultiple}
          file={fileDelegation}
          encodingType={encodingTypeDelegation}
          handleUploadCsv={handleUploadCsvDelegation}
          setEncodingType={setEncodingTypeDelegation}
          onChangeModalUploadCsv={onChangeModalUploadCsvDelegation}
          onHandleClickClose={onHandleClickCloseDelegation}
        />
      )}
    </S.CustomModal>
  )
}

export default CsvUploadModal
